export const ADD_EMOJI = 'ADD_EMOJI';
export const ADD_PRE_EMOJIS = 'ADD_PRE_EMOJIS';
export const REMOVE_EMOJI = 'REMOVE_EMOJI';
export const UPDATE_EMOJIS = 'UPDATE_EMOJIS';
export const SET_SEARCH_EMOJI = 'SET_SEARCH_EMOJI';
export const NEXT_SEARCH_EMOJI = 'NEXT_SEARCH_EMOJI';
export const PREV_SEARCH_EMOJI = 'PREV_SEARCH_EMOJI';
export const SET_INPUT_VALUE = 'SET_INPUT_VALUE';
export const SET_INPUT_FOCUSED = 'SET_INPUT_FOCUSED';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const PASTE_EMOJI = 'PASTE_EMOJI';
export const COPY_EMOJI = 'COPY_EMOJI';
export const UPDATE_STATUS = 'UPDATE_STATUS';
export const INIT_SELECT_INDEX = 'INIT_SELECT_INDEX';
export const SET_WASM_FILTER = 'SET_WASM_FILTER';
export const SET_EMOJI_LIST = 'SET_EMOJI_LIST';
export const SET_RHYTHM_SCORE = 'SET_RHYTHM_SCORE';
export const SET_RHYTHM_SCORE_COPY = 'SET_RHYTHM_SCORE_COPY';
export const SET_CSESSION_ID = 'SET_CSESSION_ID';
export const SET_ORDER_ITEMS = 'SET_ORDER_ITEMS';
export const GET_CART_ITEMS = 'GET_CART_ITEMS';
export const SET_SECRET_KEY = 'SET_SECRET_KEY';
export const SET_CART_ITEMS = 'SET_CART_ITEMS';
export const ACTION_RESET_PICKER_STORE = 'ACTION_RESET_PICKER_STORE';

export const SET_DELETE_CART_ITEM_REQUEST_IN_PROGRESS = 'SET_DELETE_CART_ITEM_REQUEST_IN_PROGRESS';

export type EmojiListStatus = 'YAT_DEFINED' | 'YAT_UNDEFINED';

export type Emoji = string[];

export interface currentIndexInteractionResponse {
    newIndex: number;
    newIndexAffectsInput: boolean;
}
